<template>
  <div>
    <div class="row text-white" style="background: #44927b">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>
    <simple-row :name="'Файл'" :value="fieldView(object.name)"></simple-row>
    <simple-row :name="'Описание'" :value="fieldView(object.description)"></simple-row>
    <div class="row">
      <div class="col-md-12">
        <button v-on:click="downloadFile">Загрузить</button>
      </div>
    </div>
  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       object: this.item.object,
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async downloadFile() {
       let url = 'file/download/' + this.object.id + '-' +  this.object.callName;
       await this.$repo.downloadFile(url, this.object.name)
     }
   }
 }
</script>
<style>
</style>
